import { render, staticRenderFns } from "./ErrandsDetails.vue?vue&type=template&id=703f4938&scoped=true&"
import script from "./ErrandsDetails.vue?vue&type=script&lang=js&"
export * from "./ErrandsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ErrandsDetails.vue?vue&type=style&index=0&id=703f4938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f4938",
  null
  
)

export default component.exports